import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-finance-bill-exception",
  "use": "icon-finance-bill-exception-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-finance-bill-exception\"><path d=\"M197,185.83H23.05V147.19H197Zm-164.9-9H188V156.19H32.05Z\" /><path d=\"M177.49,155h-135V101.66a67.49,67.49,0,0,1,135,0Zm-126-9h117V101.66a58.49,58.49,0,0,0-117,0Z\" /><rect x=\"105.5\" y=\"63.78\" width=\"9\" height=\"40.35\" /><rect x=\"105.5\" y=\"117.72\" width=\"9\" height=\"11.12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol